import { Fragment, useState } from 'react'
import AuthLayout from '../layouts/AuthLayout'
import toast from 'react-hot-toast'
import PrimaryButton from '../buttons/PrimaryButton'
import Select from "react-select";
import { numberRange } from '../../utils/helpers/logicHelper';
import { emailValidator, phoneValidator } from '../../utils/services/validator.service';
// import { InputValidator } from '../../modules/enums';
import APIService from '../../utils/services/api.service';
import { Loading } from '../../utils/services/constants';
import { Image } from 'react-bootstrap';
import SuccessSVG from "../../assets/images/svgs/Successful.svg";
import closeSVG from "../../assets/images/svgs/close-circle.svg";
import { useNavigate } from 'react-router-dom';
import { customSelectStyles } from '../../utils/helpers/customStyles';

const SupplyLead = () => {

  const [step, setStep] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState<string>();
  const [categorySize, setCategorySize] = useState("");
  const [loadState, setLoadState] = useState(false);

  // const [emailErrorState, setEmailErrorState] = useState(false);
  const [phoneErrorState, setPhoneErrorState] = useState(false);

  const navigate = useNavigate();

  const isInvalid = !firstName || !lastName || !phoneNumber || phoneErrorState || !state || !categorySize;

  const goBack = () => {
    navigate(-1);
  }

  const vehicleSizes = [1, 2 , 3, 5, 10, 15, 20, 30, 45];

  const vehicleTonnages = numberRange(vehicleSizes).map(option => ({
    ...option,
    value: option.value.toString()
  }));

  const handleFieldValidation = (data: string, field: 'email' | 'phone') => {
    if (field === 'email') {
      const validatedEmail = emailValidator(data);
      setEmail(validatedEmail.validEmail);
      // const isEmailValid = validatedEmail.validState !== InputValidator.VALID;
      // setEmailErrorState(isEmailValid);
      return;
    }

    const phoneValue = data.trim();
    setPhoneNumber(phoneValue);
    const isPhoneValid = phoneValidator(phoneValue);
    setPhoneErrorState(!isPhoneValid);
  };

  const handleSubmit = async () => {
    setLoadState(true);

    let extras = {
      is_vehicle: true,
      category_size: categorySize.toString(),
      state: state || "",
      phone: phoneNumber
    };
    let payload = { type: "DIGITAL_ADS", email, first_name: firstName, last_name: lastName, extras };
    const { data: responseData } = await APIService.onBoardSupplyLead(payload);
    if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message);
    else {
      toast.success(responseData.message);
      setStep(2)
    }
    setLoadState(false);
  }


  return (
    <AuthLayout step={step}>
      <Fragment>
        {step === 1 && (
          <Fragment>
            <h4 className="text-start mt-1 mt-lg-5 text-black">
              Become a Partner
            </h4>
            <p className="text-office-brown-700 mb-3 text-start">
              Make more money with your vehicles
            </p>

            <div className="form-floating my-4">
              <input
                type="text"
                className="form-control form-lightblue"
                value={firstName}
                placeholder="full_name"
                onChange={(e) => setFirstName(e.target.value)}
              />
              <label>First Name</label>
            </div>
            <div className="form-floating my-4">
              <input
                type="text"
                className="form-control form-lightblue"
                value={lastName}
                placeholder="full_name"
                onChange={(e) => setLastName(e.target.value)}
              />
              <label>Last Name</label>
            </div>

              <div className="d-flex flex-column">
                <div className={`form-floating mb-4 order-1`}>
                  <input
                    type="text" placeholder="email address" value={email}
                    className={`form-control form-lightblue`}
                    onChange={(e) => handleFieldValidation(e.target.value, 'email')} />
                  <label> Email Address</label>
                </div>
                <div className={`form-floating mb-4 order-2`}>
                  <input
                    type="text"
                    className={`form-control form-lightblue ${phoneErrorState && "is-invalid"}`}
                    value={phoneNumber}
                    placeholder="phone_number"
                    onChange={(e) => handleFieldValidation(e.target.value, 'phone')}
                  />
                  <label>Phone Number</label>
                </div>
                <div className={`form-floating mb-4 order-2`}>
                  <input
                    type="text"
                    className="form-control form-lightblue"
                    value={state}
                    placeholder="state"
                    onChange={(e) => setState(e.target.value)}
                  />
                  <label>State</label>
                </div>
                <div className={`form-floating mb-4 order-2`}>
                  <Select<{ value: string; label: string }, false>
                    options={vehicleTonnages}
                    isClearable={true}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="top"
                    menuPosition="fixed"
                    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                    onChange={(option) => setCategorySize(option ? option.value : "")}
                    className="form-field__input__select bg-lilac"
                    placeholder={`Select your vehicle tonnage..`}
                    styles={customSelectStyles}
                  />
                </div>
              </div>
            
          
            <PrimaryButton
              btn={{
                text: 'Save',
                loadState: loadState,
                disabledState: isInvalid,
                btnClassName: 'btn-block my-4 fw-bold w-100',
                clickFn: () => handleSubmit()
              }} />

          </Fragment>
        )}

        {step === 2 && (
          <Fragment>
            <div className="my-5 success-card">
              <p onClick={goBack} className="py-4 cursor-pointer"><Image src={closeSVG} alt="close" className="me-2" />Close</p>
              <Image src={SuccessSVG} alt="successful" width={200} height={180} className="mx-auto mb-3" />
              <h4 className="text-success-dark text-center py-3">Details have been saved!</h4>
              <p className="text-medium text-center font-size-14">A whole new world of logistics possibilities awaits!</p>
              <p className="text-medium text-center font-size-14">We'd reach out to you shortly</p>
              {/* <PrimaryButton
                btn={{
                  text: 'Check your Email for next steps!',
                  disabledState: isBusinessInvalid,
                  btnClassName: 'btn-block my-5 mx-auto',
                  clickFn: handleMail
                }}
              /> */}
            </div>
          </Fragment>
        )}
      </Fragment>
    </AuthLayout >
  )
}

export default SupplyLead
